import { render } from "./SpellingTestResult.vue?vue&type=template&id=6fbc6690&ts=true"
import script from "./SpellingTestResult.vue?vue&type=script&lang=ts"
export * from "./SpellingTestResult.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__